export var OrderSummaryLocation;
(function (OrderSummaryLocation) {
    OrderSummaryLocation["ORDER_FLOW"] = "OrderFlow";
    OrderSummaryLocation["CHECKOUT"] = "Checkout";
    OrderSummaryLocation["MY_MEALS"] = "MyMeals";
    OrderSummaryLocation["NONE"] = "None";
})(OrderSummaryLocation || (OrderSummaryLocation = {}));
export const getOrderSummaryLocation = (isOrderFlow, isCheckout, isMyMeals) => {
    if (isOrderFlow)
        return OrderSummaryLocation.ORDER_FLOW;
    if (isCheckout)
        return OrderSummaryLocation.CHECKOUT;
    if (isMyMeals)
        return OrderSummaryLocation.MY_MEALS;
    return OrderSummaryLocation.NONE;
};
export const getEmptyCartMessage = (orderSummaryLocation, emptyCartDisplayMessage, myMealsEmptyCartDisplayMessage) => {
    switch (orderSummaryLocation) {
        case OrderSummaryLocation.ORDER_FLOW:
            return emptyCartDisplayMessage;
        case OrderSummaryLocation.CHECKOUT:
            return emptyCartDisplayMessage;
        case OrderSummaryLocation.MY_MEALS:
            return myMealsEmptyCartDisplayMessage;
        default:
            return null;
    }
};
